import { useMutation } from '@tanstack/react-query';

import {
  fetchSubmitLabOrderSet,
  type SubmitLabOrderSetRequestT,
  type SubmitLabOrderSetResponseT,
} from '../api/submitLabOrderSet.js';

export interface SubmitLabOrderSetVariables {
  userId: string;
  data: SubmitLabOrderSetRequestT;
}

export function useSubmitLabOrderSetMutation() {
  return useMutation({
    mutationKey: ['labs', 'submit-order-set'],
    mutationFn: async ({
      userId,
      data,
    }: SubmitLabOrderSetVariables): Promise<SubmitLabOrderSetResponseT> => {
      return await fetchSubmitLabOrderSet(userId, data);
    },
  });
}
